module.exports = __webpack_public_path__ + "static/media/section-6-2.4dd73580.svg";